{
  "backToPost": "Bumalik sa post",
  "needsApproval": "Kailangan ng pag-apruba",
  "postCancelled": "Kinansela ang event na ito. Naabisuhan na ang mga nagparehistro.",
  "summary": "Buod",
  "status_pending": "Naghihintay",
  "status_confirmed": "Kumpirmado",
  "status_waitlisted": "Nasa waitlist",
  "status_declined": "Tinanggihan",
  "status_cancelled": "Kanselado",
  "filter_active": "Aktibo",
  "filter_pending": "Naghihintay",
  "filter_confirmed": "Kumpirmado",
  "filter_waitlisted": "Waitlist",
  "filter_declined": "Tinanggihan",
  "filter_cancelled": "Kanselado",
  "filter_all": "Lahat",
  "checkedIn": "Naka-check in",
  "notCheckedIn": "Hindi pa naka-check in",
  "anyAttendance": "Kahit anong attendance",
  "seatsTotal": "Nagamit na slot",
  "sessionCancelled": "kanselado",
  "waitlistN": "{count} naghihintay",
  "search": "Hanapin ang pangalan, mobile o ticket",
  "session": "Petsa / oras",
  "allSessions": "Lahat ng petsa",
  "chooseSession": "Pumili ng petsa",
  "showing": "Ipinapakita ang {count} sa {total}",
  "empty": "Wala pang nagparehistro",
  "emptyBody": "Ibahagi ang link ng post sa inyong Facebook page para magparehistro ang mga residente sa app.",
  "emptyFilter": "Walang nagparehistro na tugma sa mga filter",
  "plusCompanions": "+{count} kasama",
  "registeredOn": "Nagparehistro {date}",
  "registeredAt": "Nagparehistro",
  "walkIn": "Walk-in",
  "checkedInAt": "Nag-check in {time}",
  "decide": "Aprubahan o tanggihan",
  "checkIn": "I-check in",
  "undoCheckIn": "I-undo ang check-in",
  "cancelReg": "Kanselahin",
  "confirmCancel": "Kanselahin ang rehistro ni {name}? Aabisuhan siya, at aakyat ang susunod sa waitlist.",
  "checkedInToast": "Naka-check in na si {name}.",
  "undoneToast": "Na-undo ang check-in ni {name}.",
  "cancelledToast": "Nakansela ang rehistro ni {name}.",
  "decisionTitle": "Rehistro ni {name}",
  "noteToRegistrant": "Tala para sa nagparehistro",
  "noteHint": "Opsyonal. Makikita niya ito kasama ng iyong desisyon, hal. ano ang dadalhin o bakit tinanggihan.",
  "approve": "Aprubahan",
  "decline": "Tanggihan",
  "approvedToast": "Naaprubahan si {name}.",
  "declinedToast": "Tinanggihan si {name}.",
  "addWalkIn": "Magdagdag ng walk-in",
  "walkInLead": "Para sa nagpaparehistro sa mismong lugar o sa telepono. Hindi kailangan ng account; kumpirmado agad.",
  "companions": "Mga kasama",
  "checkInNow": "I-check in na ngayon",
  "overrideCapacity": "Idagdag kahit puno",
  "noLimit": "walang limit",
  "seatsLeft": "{count} slot na lang",
  "walkInAdded": "Naidagdag si {name}.",
  "sendUpdate": "Magpadala ng update",
  "sendUpdateLead": "Matatanggap ito ng lahat ng nakarehistro bilang notification sa app, hal. paalala sa pagbabago ng lugar o ano ang dadalhin.",
  "message": "Mensahe",
  "charCount": "{count} / 1000",
  "sendTo": "Ipadala sa",
  "alsoSms": "Ipadala rin bilang SMS",
  "smsNotConfigured": "Hindi pa naka-set up ang SMS para sa LGU na ito. Sa app notification lang ipapadala ang update.",
  "messageTooShort": "Sumulat ng mensaheng hindi bababa sa 3 character.",
  "messageSent": "Naipadala ang update sa {count} nagparehistro.",
  "messageSentSms": "Naipadala ang update sa {count} nagparehistro ({sms} sa SMS).",
  "messagesSent": "Mga naipadalang update",
  "recipients": "{count} tumanggap",
  "smsCount": "{count} SMS",
  "ticket": "Ticket",
  "waitlistPosition": "Puwesto sa waitlist",
  "officeNote": "Tala ng opisina",
  "sex_female": "Babae",
  "sex_male": "Lalaki",
  "sex_prefer_not_to_say": "Ayaw sabihin"
}
